import {initializer,finalizer} from 'linksoft-react';
import { initialize } from 'linksoft';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

initialize.register(initializer);
initialize.register(finalizer, true);


// WEBPACK FOOTER //
// ./App/react-init.js